import React from 'react';
import { graphql } from 'gatsby';

import SectionItemProductText from '../../../../components/Section/SectionItems/SectionItemProductText';
import { normalizeTextAlign } from '../../utils';

// Types
import { SectionItemProductTextContainerFragment } from './__generated__/SectionItemProductTextContainerFragment';
import { SectionWidth } from '../../../../../types/sections';

export const fragment = graphql`
  fragment SectionItemProductTextContainerFragment on CMS_Section {
    text
    textAlign
    textColor
  }
`;

type Props = {
  contentPositionY: string;
  hasBackgroundImage: boolean;
  section: SectionItemProductTextContainerFragment;
  sectionWidth: SectionWidth;
};

const SectionItemProductTextContainer = ({ contentPositionY, hasBackgroundImage, section, sectionWidth }: Props) => {
  const text = section.text;

  if (typeof text !== 'string') {
    return null;
  }

  const textAlign = normalizeTextAlign(section.textAlign);
  const textColor = section.textColor;

  return (
    <SectionItemProductText
      contentPositionY={contentPositionY}
      hasBackgroundImage={hasBackgroundImage}
      sectionWidth={sectionWidth}
      text={text}
      textAlign={textAlign}
      textColor={textColor}
    />
  );
};

export default SectionItemProductTextContainer;
